import React from "react";

export default function BookingFilters({
  vehicles = [],
  filterStatus,
  setFilterStatus,
  filterVehicle,
  setFilterVehicle,
  dateOrder,
  setDateOrder,
}) {
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm">
      <label className="text-gray-600 dark:text-gray-300">Status:</label>
      <select
        value={filterStatus}
        onChange={(e) => setFilterStatus(e.target.value)}
        className="rounded-lg border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800"
      >
        <option value="All">All</option>
        <option value="Pending">Pending</option>
        <option value="Confirmed">Confirmed</option>
        <option value="Completed">Completed</option>
        <option value="Cancelled">Cancelled</option>
      </select>

      <label className="text-gray-600 dark:text-gray-300">Vehicle:</label>
      <select
        value={filterVehicle}
        onChange={(e) => setFilterVehicle(e.target.value)}
        className="rounded-lg border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800"
      >
        <option value="All">All</option>
        {vehicles.map((v) => (
          <option key={v.id} value={v.id}>
            {v.model} ({v.year})
          </option>
        ))}
      </select>

      <label className="text-gray-600 dark:text-gray-300">Date order:</label>
      <select
        value={dateOrder}
        onChange={(e) => setDateOrder(e.target.value)}
        className="rounded-lg border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800"
      >
        <option value="closest">Closest to today</option>
        <option value="farthest">Farthest from today</option>
      </select>
    </div>
  );
}
